import * as React from "react";
import _ from "lodash";
import { SidingColor, hexCodeFor, colorNameMap } from "./colors";


interface ColorChooserProperties extends React.Props<ColorChooserProperties> {
    onClick: (color: SidingColor) => void;
    colors: SidingColor[];
    selected: SidingColor;
}

interface ColorChooserState {
    open: boolean;
}

export default class ColorChooser extends React.Component<ColorChooserProperties, ColorChooserState> {
    node = React.createRef<HTMLDivElement>();

    constructor(props: ColorChooserProperties) {
        super(props);
        this.state = { open: false };
    }

    onColorSelected(color: SidingColor) {
        this.setState({ open: false });
        this.props.onClick(color);
    }

    handleClick() {
        this.setState(_.extend(this.state, { open: !this.state.open }));

        if (this.state.open) {
            document.addEventListener('click', (e) => this.handleOutsideClick(e), false);
          } else {
            document.removeEventListener('click', (e) => this.handleOutsideClick(e), false);
          }
    }

    handleOutsideClick(e: MouseEvent) {

        if(!this.node || !this.node.current) return;
        if(!e.target) return;


        // ignore clicks on the component itself
        if (this.node.current.contains(e.target as Node)) {
          return;
        }

        this.setState(_.extend(this.state, { open: false }) );
    }

    render() {
        return (
            <div className="color-chooser">
                <div className="swatch" onClick={ e => { this.handleClick() } } title={colorNameMap(this.props.selected)} ref={this.node}>
                    <div style={{ backgroundColor: hexCodeFor(this.props.selected) }} />
                </div>
                <ul className="color-chooser-list" style={{display: this.state.open ? "block" : "none"}}>
                    {_(this.props.colors).map(color => {
                        return (
                            <li key={ color } className="swatch" onClick={() => this.onColorSelected(color)} title={colorNameMap(color)} >
                                <div style={{ backgroundColor: hexCodeFor(color) }} />
                            </li>
                        );
                    }).value()}
                </ul>
            </div>);
    }
}